module.exports = __webpack_public_path__ + "img/109.9.2034a49e.png";